import React from 'react'

import LoadingIndicator from '../../../../LoadingIndicator/LoadingIndicator'
import { StyledWrapper } from './styles'

const Loading = () => (
  <StyledWrapper>
    <LoadingIndicator label="" size={128} color="inherit" />
  </StyledWrapper>
)

export default Loading
